import { createContext } from "react";

const cartcontext = createContext();

export default cartcontext;